import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SponsorsSection.css';
import { API_BASE } from '../utils/api';
import SponsorShowcase from './SponsorShowcase';

/**
 * Ana sayfadaki sponsor bölümü. Sponsorlar kademe hiyerarşisiyle SponsorShowcase
 * üzerinden gösterilir; aynı bileşen /sponsorluk sayfasında da kullanılıyor.
 */
const SponsorsSection = () => {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/api/sponsors`)
      .then((r) => r.json())
      .then((data) => { if (data.success) setSponsors(data.items || []); })
      .catch(() => {});
  }, []);

  if (sponsors.length === 0) return null;

  return (
    <section className="sponsors-section" aria-labelledby="sponsors-title">
      <div className="sponsors-container">
        {/* Sayfanın tek H1'i HomeIntro'da; burası H2 */}
        <h2 id="sponsors-title" className="sponsors-main-title">Sponsorlarımız</h2>
        <p className="sponsors-subtitle">
          Derneğimizin yanında yer alan, bu yolculuğun değerli paydaşları.
        </p>

        <SponsorShowcase sponsors={sponsors} variant="home" headingLevel="h3" />

        {/* Doğrudan başvuru formuna götürür; kaydırmayı SponsorshipPage üstleniyor */}
        <Link to="/sponsorluk#sponsorluk-formu" className="sponsors-cta">
          Sponsorumuz Olun <span aria-hidden="true">→</span>
        </Link>
      </div>
    </section>
  );
};

export default SponsorsSection;
